export default [
  {
    path: "/report", // 报告
    name: "report",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Report/index.vue"),
  },
];
